var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal',{attrs:{"to":_vm.target}},[_c('transition',{attrs:{"name":"modal"}},[(_vm.show)?_c('div',{staticClass:"modal modal__mask",class:_vm.className,on:{"click":function($event){!_vm.disableOutSideClick ? _vm.close() : () => void 0}}},[_c('div',{staticClass:"modal__container",class:{
					small: _vm.size == 'small',
					large: _vm.size == 'large',
					auto: _vm.size == 'auto',
					max: _vm.size == 'max',
				},on:{"click":function($event){$event.stopPropagation();}}},[(_vm.showCloseButton)?_c('button',{staticClass:"modal__x",class:_vm.positionCloseX ? _vm.positionCloseX : '',on:{"click":_vm.close}},[_vm._v("\n\t\t\t\t\t×\n\t\t\t\t")]):_vm._e(),_vm._v(" "),_vm._t("modal-content")],2)]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }